import { useState } from 'react';
import { GhostButton, Note } from '../ui';

// Screenshot viewer: buttons, thumbnails and arrow keys. No autoplay.
export default function Gallery({ images }) {
  const [index, setIndex] = useState(0);
  const count = images.length;
  const current = images[index];
  const go = (i) => setIndex((i + count) % count);

  const onKeyDown = (e) => {
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      go(index - 1);
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      go(index + 1);
    }
  };

  return (
    <div role="group" aria-roledescription="carousel" aria-label="Project screens" onKeyDown={onKeyDown}>
      <div className="aspect-[1919/990] w-full overflow-hidden rounded-frame bg-paper-2">
        <img
          key={current.src}
          src={`${current.src}-1280.webp`}
          srcSet={`${current.src}-640.webp 640w, ${current.src}-1280.webp 1280w`}
          sizes="(min-width: 900px) 66vw, 100vw"
          width={current.width}
          height={current.height}
          alt={current.alt}
          className="h-full w-full object-contain"
        />
      </div>

      <div className="mt-4 flex flex-wrap items-center justify-between gap-x-6 gap-y-2">
        <Note aria-live="polite">
          {index + 1} / {count} · {current.caption}
        </Note>
        <div className="flex gap-4">
          <GhostButton onClick={() => go(index - 1)}>Previous</GhostButton>
          <GhostButton onClick={() => go(index + 1)}>Next</GhostButton>
        </div>
      </div>

      <ul className="mt-4 flex gap-3 overflow-x-auto pb-2">
        {images.map((img, i) => (
          <li key={img.src} className="shrink-0">
            <button
              type="button"
              onClick={() => go(i)}
              aria-label={`Show ${img.caption}`}
              aria-current={i === index}
              className="block min-h-11 focus-visible:bg-mark"
            >
              <img
                src={`${img.src}-640.webp`}
                width={img.width}
                height={img.height}
                alt=""
                loading="lazy"
                className={`h-14 w-auto rounded-frame bg-paper-2 transition-opacity duration-fast md:h-16 ${
                  i === index ? 'opacity-100' : 'opacity-60 hover:opacity-100'
                }`}
              />
              <span className={`mt-1 block h-1 ${i === index ? 'bg-mark' : 'bg-transparent'}`} />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
